// extracted by css-extract-rspack-plugin
export default {"order_icon":"r6nJl","orderIcon":"r6nJl","subtitle":"GTNAL","wrapper":"Zza1z"};